// extracted by mini-css-extract-plugin
export default {"icon-title":"RecentPage_icon-title__H0lgO"};